import { supabase } from '@/integrations/supabase/client';

export type ConsentPreferences = {
  consent_data_processing: boolean;
  consent_ai_tips: boolean;
  consent_anonymous_insights: boolean;
};

export const NO_HEALTH_CONSENT: ConsentPreferences = {
  consent_data_processing: false,
  consent_ai_tips: false,
  consent_anonymous_insights: false,
};

export async function loadHealthConsentPreferences(userId: string, signal?: AbortSignal): Promise<ConsentPreferences> {
  if (!userId) throw new Error('Authentication required');
  const query = supabase.from('profiles')
    .select('consent_data_processing, consent_ai_tips, consent_anonymous_insights')
    .eq('id', userId);
  const { data, error } = await (signal ? query.abortSignal(signal) : query).maybeSingle();
  if (error) throw error;
  if (!data) throw new Error('Profile unavailable');
  return {
    consent_data_processing: data.consent_data_processing === true,
    consent_ai_tips: data.consent_ai_tips === true,
    consent_anonymous_insights: data.consent_anonymous_insights === true,
  };
}
